import { render, staticRenderFns } from "./VocationQR.vue?vue&type=template&id=ba5d0884&scoped=true"
import script from "./VocationQR.vue?vue&type=script&lang=js"
export * from "./VocationQR.vue?vue&type=script&lang=js"
import style0 from "./VocationQR.vue?vue&type=style&index=0&id=ba5d0884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5d0884",
  null
  
)

export default component.exports